export interface FounderImpersonationUserSummary {
  uid: string;
  phoneNumber: string | null;
  displayName: string | null;
  email: string | null;
  identifier?: string;
  username?: string | null;
  exactMatchType?: 'uid' | 'phone' | 'email' | null;
}

export interface WebImpersonationSession {
  sessionId: string;
  source: 'web_admin';
  launchPath?: string;
  founderUser: FounderImpersonationUserSummary;
  targetUser: FounderImpersonationUserSummary;
  startedAt: string;
}

const STORAGE_KEY = 'clero_web_impersonation_session';
const EVENT_NAME = 'clero:web-impersonation-updated';

const dispatchImpersonationEvent = () => {
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const getWebImpersonationStorageKey = () => STORAGE_KEY;
export const getWebImpersonationEventName = () => EVENT_NAME;

export const readWebImpersonationSession = (): WebImpersonationSession | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as WebImpersonationSession;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const persistWebImpersonationSession = (session: WebImpersonationSession) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  dispatchImpersonationEvent();
};

export const clearWebImpersonationSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
  dispatchImpersonationEvent();
};

export const clearPublicImpersonationCaches = () => {
  localStorage.removeItem('clero_verified_phone');
  localStorage.removeItem('clero_last_session');
  localStorage.removeItem('clero_lookup_phone');
  sessionStorage.removeItem('clero_lookup_results');

  const localKeysToRemove: string[] = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key) continue;
    if (key.startsWith('clero_verified_') || key.startsWith('clero_lookup_name_')) {
      localKeysToRemove.push(key);
    }
  }
  localKeysToRemove.forEach((key) => localStorage.removeItem(key));
};
